//React
import React, { useEffect, useState } from "react";
//Components
import { FlexBox, Card, StatusMark, Image } from "components";
//Styles
import "./styles.scss";
//Types
import { CodeProps } from "./types";
//Assets
import CopyIcon from "assets/icons/copy.png";
//Utils
import { copyText } from "utils";
//Libraires
import SyntaxHighlighter from "react-syntax-highlighter";
import { androidstudio } from "react-syntax-highlighter/dist/esm/styles/hljs";
import cx from "classnames";
var lastScrollTop = 0;
const Code: React.FC<CodeProps> = ({
  className,
  code,
  language = "javascript",
  onScroll,
  id,
}) => {
  useEffect(() => {
    // setTimeout(() => {
    //   //@ts-ignore
    //   document
    //     .querySelector(".language-html")
    //     .addEventListener("scroll", scroll);
    // }, 0);
  }, []);

  // function scroll(evt) {
  //   var st =
  //     window.pageYOffset ||
  //     //@ts-ignore
  //     document.querySelector(".language-html").scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
  //   if (st > lastScrollTop) {
  //     // downscroll code
  //     onScroll("down");
  //     //@ts-ignore
  //     document
  //       .querySelector(".language-html")
  //       .removeEventListener("scroll", scroll);
  //     setTimeout(() => {
  //       //@ts-ignore
  //       document
  //         .querySelector(".language-html")
  //         .addEventListener("scroll", scroll);
  //     }, 1000);
  //   } else if (st < lastScrollTop) {
  //     // upscroll code
  //     onScroll("up");
  //     //@ts-ignore
  //     document
  //       .querySelector(".language-html")
  //       .removeEventListener("scroll", scroll);
  //     setTimeout(() => {
  //       //@ts-ignore
  //       document
  //         .querySelector(".language-html")
  //         .addEventListener("scroll", scroll);
  //     }, 1000);
  //   } // else was horizontal scroll
  //   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  // }

  return (
    <div className={cx(className, "code-block pos-rel")}>
      {/* <Image
        src={CopyIcon}
        className="copy-img clicking-animation"
        onClick={() => {
          copyText(code, "Code Copied");
        }}
      /> */}
      <SyntaxHighlighter language={language} style={androidstudio}>
        {code}
      </SyntaxHighlighter>
    </div>
  );
};
export default Code;
